import { useQuery } from "@apollo/client/react";
import { MembersListDataDocument, type MembersListDataQuery } from "#app/lib/data";

// The roles/teams sibling connections ride MembersListData, so `limit: 1`
// keeps the unused user payload minimal (the same side-load trick as
// use-role-pool; Apollo deduplicates the two).
const SIBLING_DATA_VARS = { limit: 1 };

/**
 * Fetches the members list document purely for its sibling connections
 * (roles, teams). Used by the members table when grouped — grouped state
 * never mounts the ungrouped provider those connections normally ride on.
 */
export function useMembersSiblingData(skip: boolean): MembersListDataQuery | undefined {
  const { data } = useQuery(MembersListDataDocument, {
    variables: SIBLING_DATA_VARS,
    skip,
  });
  return data;
}
